import moment from "moment";

export class RogersPayoutReportService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    retrieveRogersLivePayoutReportJobs() {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/rogers",
            //params: query
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveRogersLivePayoutReport(query) {
        //return this.createRogersLivePayoutReportJob(query);
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/rogers/live-payout-report",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    createRogersLivePayoutReportJob(query) {
        return this.$http({
            method: "POST",
            url: this.apexApiUrl + "reports/rogers/create-job-live-payout-report",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveRogersPostedPayoutReport(query) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/rogers/posted-payout-report",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveRogersPostedPayoutExceptionsReport(query) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/rogers/posted-payout-exceptions-report",
            params: {
                PostedDate: moment(query.PostedDate).format("YYYY-MM-DD"),
                IcdCorporationID: query.IcdCorporationID
            }
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveRogersHybridPayoutReport(query) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/rogers/hybrid-payout-report",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveRogersOwnerHybridPayoutReport(query) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/rogers/owner-hybrid-payout-report",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveRogersPayoutRateTable(query) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/payout-policies/payout-rate-table",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    retrieveRogersEmployeeCommissionStatement(query) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "reports/rogers/employee-commission-statement",
            params: query
        }).then(function (response) {
            return response.data;
        });
    }
}
